/* eslint-disable no-unused-vars */
import { Grid, Typography, CircularProgress } from "@mui/material";
import PConfirm from "../../components/pos/PConfirm";
import PDialog from "../../components/pos/PDialog";
import PSelect from "../../components/pos/PSelect";
import PCheck from "../../components/pos/PCheck";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import { SyncUtils } from "../../utils/SyncUtils";

export default function VendorCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [contact, setContact] = useState("");
  const [contactError, setContactError] = useState("");
  const [address, setAddress] = useState("");
  const [addressError, setAddressError] = useState("");
  const [trn, setTrn] = useState("");
  const [trnError, setTrnError] = useState("");
  const [paymentMode, setPaymentmode] = useState({ name: "CREDIT", id: 1 });
  const [paymentModeError, setPaymentmodeError] = useState("");
  const [paymentTerms, setPaymentterms] = useState("");
  const [paymentTermsError, setPaymenttermsError] = useState("");
  const [openingAmount, setOpeningAmount] = useState(0);
  const [openingNature, setOpeningNature] = useState("");
  const [openingNatureError, setOpeningNatureError] = useState("");
  const [taxRegistered, setTaxRegistered] = useState(false);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showVendorCrudWindow: showVendorCrudWindow,
  };

  const paymentTermsOptions = [
    { name: "7 DAYS", id: 1 },
    { name: "10 DAYS", id: 6 },
    { name: "15 DAYS", id: 2 },
    { name: "30 DAYS", id: 3 },
    { name: "45 DAYS", id: 7 },
    { name: "60 DAYS", id: 8 },
    { name: "90 DAYS", id: 4 },
    { name: "100 DAYS", id: 5 },
  ];

  const paymentModeOptions = [
    { name: "CREDIT", id: 1 },
    { name: "CASH", id: 2 },
    { name: "BANK", id: 3 },
  ];

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.name);
    }
  }, [origObject]);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && code === "")
      setCodeError(translate("Code is Required"));
    else setCodeError("");
  }, [code]);
  useEffect(() => {
    if (liveValidation && contact === "")
      setContactError(translate("Contact is Required"));
    else setContactError("");
  }, [contact]);
  useEffect(() => {
    if (liveValidation && address === "")
      setAddressError(translate("Address is Required"));
    else setAddressError("");
  }, [address]);
  useEffect(() => {
    if (liveValidation && trn === "") setTrnError(translate("Trn is Required"));
    else setTrnError("");
  }, [trn]);
  useEffect(() => {
    if (liveValidation && paymentTerms === "" && paymentMode.name === "CREDIT")
      setPaymenttermsError(translate("Trn is Required"));
    else setPaymenttermsError("");
  }, [paymentMode]);
  useEffect(() => {
    if (liveValidation && paymentTerms === "" && paymentMode.name === "CREDIT")
      setPaymenttermsError(translate("Payment Terms Required"));
    else setPaymenttermsError("");
  }, [paymentTerms]);
  useEffect(() => {
    if (liveValidation && trn === "" && taxRegistered)
      setTrnError(translate("Trn Required"));
    else if (taxRegistered && trn != "" && trn.length != 15) {
      setTrnError(translate("Length should be 15"));
    } else setTrnError("");
  }, [trn]);
  useEffect(() => {
    if (liveValidation && taxRegistered && trn === "")
      setTrnError(translate("Trn Required"));
    else setTrnError("");
  }, [taxRegistered]);
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showVendorCrudWindow(vendorId) {
    if (vendorId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
      setWindowTitile("New Vendor");
    } else {
      setMode(
        props.context.privileges.vendor_edit ||
          props.context.privileges.vendor_delete
          ? "edit"
          : "view"
      );
      populateVendor(vendorId);
    }
  }
  async function populateVendor(id) {
    {
      try {
        let { data } = await API.get("/api/v1/vendor/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Vendor data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setName(bean.name);
    setCode(bean.code);
    setContact(bean.contact1);
    setAddress(bean.address1);
    setTrn(bean.trnNo);
    setTaxRegistered(bean.taxRegistered);
    setOpeningAmount(bean.openingBalance);
    setOpeningNature(bean.openingNature ? { name: bean.openingNature } : null);
    if (bean.paymentModeId) {
      setPaymentmode({
        name: bean.paymentMode,
        id: bean.paymentModeId,
      });
    }

    if (bean.paymentTermsId) {
      setPaymentterms({
        name: bean.paymentTerms,
        id: bean.paymentTermsId,
      });
    } else {
      setPaymentterms("");
    }

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setCode("AUTO");
    setCodeError("");
    setContact("");
    setContactError("");
    setAddress("");
    setAddressError("");
    setTrn("");
    setTrnError("");
    setPaymentmode({ name: "CREDIT", id: 1 });
    setPaymentmodeError("");
    setPaymentterms("");
    setPaymenttermsError("");
    setOpeningAmount(0);
    setOpeningNature("");
    setOpeningNatureError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete vendor") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/vendor/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Vendor") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Vendor"));
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/vendor", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        if (props.onRefresh != null && props.onRefresh != undefined)
          props.onRefresh();
        if (props.selectVendor != null && props.selectVendor != undefined)
          props.selectVendor(result.data);
        showProgress(false, "Saving");
        setOpenWindow(false);
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Vendor"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "code") {
        setCodeError(obj.message);
      }
      if (obj.field === "contact") {
        setContactError(obj.message);
      }
      if (obj.field === "address") {
        setAddressError(obj.message);
      }
      if (obj.field === "trn") {
        setTrnError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
      saveObject["ledgerId"] = origObject.ledgerId;
    }
    saveObject["openingBalance"] = openingAmount;
    saveObject["openingNature"] = openingNature ? openingNature.name : null;
    saveObject["code"] = code;
    saveObject["contact1"] = contact;
    saveObject["address1"] = address;
    saveObject["trnNo"] = trn;
    saveObject["taxRegistered"] = taxRegistered;
    saveObject["paymentMode"] = paymentMode.name;
    saveObject["paymentTerms"] = paymentTerms.name;
    saveObject["paymentModeId"] = paymentMode.id;
    saveObject["paymentTermsId"] = paymentTerms.id;
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    if (!code || code === "") {
      setCodeError(translate("Code is Required"));
      flag = false;
    }
    if (!contact || contact === "") {
      setContactError(translate("Contact is Required"));
      flag = false;
    }
    if (!address || address === "") {
      setAddressError(translate("Address is Required"));
      flag = false;
    }
    if ((!trn || trn === "") && taxRegistered) {
      setTrnError(translate("Trn is Required"));
      flag = false;
    }
    if (!paymentTerms && paymentMode.name === "CREDIT") {
      setPaymenttermsError(translate("Payment Terms Required"));
      flag = false;
    }
    if (
      openingAmount > 0 &&
      (openingNature === "" || openingNature == undefined)
    ) {
      setOpeningNatureError(translate("Account nature required"));
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Code")}</Typography>
                </td>
                <td>
                  <PText
                    value={code}
                    error={codeError}
                    onChange={(e) => setCode(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Name")}</Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <PCheck
                    onChange={(value) => {
                      setTaxRegistered(value);
                    }}
                    checked={taxRegistered}
                    label={translate("Tax Registered")}
                  ></PCheck>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Trn")}</Typography>
                </td>
                <td>
                  <PText
                    value={trn}
                    error={trnError}
                    onChange={(e) => setTrn(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Contact")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={contact}
                    error={contactError}
                    onChange={(e) => setContact(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Address")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={address}
                    error={addressError}
                    onChange={(e) => setAddress(e.target.value)}
                  ></PText>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Payment Mode")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    options={paymentModeOptions}
                    value={paymentMode}
                    errorMessage={paymentModeError}
                    onChange={(event, newValue) => {
                      setPaymentmode(newValue);
                      if (newValue != "CREDIT") setPaymentterms("");
                    }}
                  ></PSelect>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Payment Terms")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    options={paymentTermsOptions}
                    value={paymentTerms}
                    placeholder={translate("Select...")}
                    disabled={
                      paymentMode == null || paymentMode.name == "CREDIT"
                        ? false
                        : true
                    }
                    errorMessage={paymentTermsError}
                    onChange={(event, newValue) => {
                      setPaymentterms(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Opening Amount")}
                  </Typography>
                </td>
                <td>
                  <PText
                    type="number"
                    value={openingAmount}
                    onChange={(e) => setOpeningAmount(e.target.value)}
                    disabled={mode === "edit" ? true : false}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Nature")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={[
                      { id: "credit", name: "CREDIT" },
                      { id: "debit", name: "DEBIT" },
                    ]}
                    placeholder={translate("Select...")}
                    value={openingNature}
                    disabled={
                      openingAmount > 0 && mode === "create" ? false : true
                    }
                    errorMessage={openingNatureError}
                    onChange={(event, newValue) => {
                      setOpeningNature(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    if (mode === "create") {
      if (code || code != "") return true;
    }
    if (mode === "edit") {
      if (code !== origObject.code) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/

    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={props.context.privileges.vendor_delete ? onDelete : false}
          mode={mode}
          isDataChanged={isDataChanged}
          hideSave={
            (!props.context.privileges.vendor_edit &&
              props.context.privileges.vendor_delete) ||
              mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
